import { filterByLocationTitleAndAddress } from '@/utils/functions/storeLocations/filterByTitleAndAddress'
import { forwardRef } from 'react'
import { SearchSelect, type SearchSelectProps } from '../selects/SearchSelect'
import { type OptionProps, type SelectRefType } from '../selects/Select'
import { type FormattedTitleWithAddressProps } from './FormattedTitleWithAddress'

interface AntdOptionProps extends OptionProps {
  label: React.ReactElement<FormattedTitleWithAddressProps>
}

export const StoreLocationSearchSelect = forwardRef<SelectRefType, SearchSelectProps>(
  ({ match = 'both', ...props }, ref) => {
    return (
      <SearchSelect
        ref={ref}
        {...props}
        filterOption={(inputValue: string, option) => {
          const { label: labelComponent, value } = option as unknown as AntdOptionProps

          const matchLabel = filterByLocationTitleAndAddress(
            inputValue,
            labelComponent.props.location,
          )

          const txt = inputValue.toLowerCase()
          const matchValue = value.toLowerCase().includes(txt)

          if (match === 'label') return matchLabel
          else if (match === 'value') return matchValue
          else return matchLabel ?? matchValue
        }}
      />
    )
  },
)

StoreLocationSearchSelect.displayName = 'StoreLocationSearchSelect'
